import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-buttonblock',
    templateUrl: './buttonblock.component.html',
    styleUrls: ['./buttonblock.component.scss'],
    standalone: false
})
export class ButtonBlockComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
